export default __webpack_public_path__ + "static/media/disposal-inventory.92a72473.svg";